"use client";

import type { CSSProperties, ReactElement } from "react";
import {
  CmarkdownvisualError,
  CmarkdownvisualErrorReason,
  CmarkdownvisualType,
} from "../Cmarkdownvisual";
import { CmarkdownganttView } from "./CmarkdownganttView";
import { useCmarkdownganttController } from "./useCmarkdownganttController";

export interface CmarkdownganttProps {
  content: string;
  className?: string;
  style?: CSSProperties;
}

export function Cmarkdowngantt({
  content,
  className,
  style,
}: CmarkdownganttProps): ReactElement {
  const controller = useCmarkdownganttController({ content });

  if (!controller) {
    return (
      <CmarkdownvisualError
        dataElScope="Cmarkdowngantt/Visual"
        type={CmarkdownvisualType.Gantt}
        reason={CmarkdownvisualErrorReason.Unparseable}
      />
    );
  }

  return (
    <CmarkdownganttView
      controller={controller}
      className={className}
      style={style}
    />
  );
}
